export const normalizeString = (str) => {
  if (!str) {
    return str;
  }
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // Remove diacritics
    .replace(/[^\w\s]/g, "") // Remove punctuation and special characters
    .replace(/\s+/g, " ") // Replace multiple spaces with a single space
    .trim();
};

export const formatCPF = (value) => {
  // Remove all non-digits
  const numbers = value.replace(/\D/g, '');
  
  // Apply CPF mask: ###.###.###-##
  if (numbers.length <= 3) return numbers;
  if (numbers.length <= 6) return `${numbers.slice(0, 3)}.${numbers.slice(3)}`;
  if (numbers.length <= 9) return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6)}`;
  return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6, 9)}-${numbers.slice(9, 11)}`;
};

export const formatPhone = (value) => {
  // Remove all non-digits
  const numbers = value.replace(/\D/g, '');
  
  // Apply phone mask: (##) #####-####
  if (numbers.length <= 2) return numbers;
  if (numbers.length <= 7) return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
  return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
};


export const truncateString = (str, maxLength) => {
  if (str.length <= maxLength) return str;
  return str.slice(0, maxLength) + '...';
};